import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../sdk_initialization';

const ReservationsReport = () => {
  const [eventId, setEventId] = useState('');
  const [layoutId, setLayoutId] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const col = collection(db, 'boothReservations');
      const clauses = [];
      if (eventId) clauses.push(where('eventId', '==', eventId));
      if (layoutId) clauses.push(where('layoutId', '==', layoutId));
      const q = clauses.length ? query(col, ...clauses) : query(col);
      const snap = await getDocs(q);
      const list = [];
      snap.forEach(d => {
        const data = d.data();
        list.push({ id: d.id, ...data });
      });
      setRows(list);
    } catch (e) {
      console.warn(e);
      alert('Failed to load report: ' + (e?.message || e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // no auto-load
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <h2>Admin: Reservations Report</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input placeholder="Event ID (optional)" value={eventId} onChange={e => setEventId(e.target.value)} />
        <input placeholder="Layout ID (optional)" value={layoutId} onChange={e => setLayoutId(e.target.value)} />
        <button onClick={fetchData} disabled={loading}>{loading ? 'Loading…' : 'Load'}</button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>Booth</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>Status</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>Profile</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>Session</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>Created</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>Expires</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>Reason</th>
              <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '6px 8px' }}>By</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan="8" style={{ padding: 12, color: '#666' }}>No data</td></tr>
            ) : rows.map(r => (
              <tr key={r.id}>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.boothId}</td>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.status}</td>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.profileId || ''}</td>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.sessionId || ''}</td>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.createdAt?.toDate ? r.createdAt.toDate().toLocaleString() : (r.createdAt || '')}</td>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.expiresAt?.toDate ? r.expiresAt.toDate().toLocaleString() : (r.expiresAt || '')}</td>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.reason || ''}</td>
                <td style={{ padding: '6px 8px', borderBottom: '1px solid #f0f0f0' }}>{r.createdBy || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReservationsReport;
